import { NgModule } from "@angular/core";
import { SharedModule } from "../../core/shared/shared.module";
import { IssuesRest } from "../issues.rest";
import { IssueHeaderComponent } from "./issue-header/issue-header.component";
import { IssueDetailsComponent } from "./issue-details/issue-details.component";
import { IssueDetailsRouting } from "./issue-details.routing";
import { IssueElementsComponent } from "./issue-elements/issue-elements.component";
import { IssueElementModalComponent } from './issue-element-modal/issue-element-modal.component';
import { CustomersListModule } from "../../company/customers/customers-list/customers-list.module";
import { ProjectsRowsModule } from "../../projects/project-rows/project-rows.module";
import { ProjectRowsComponent } from "../../projects/project-rows/project-rows.component";
import { EmployeesListComponent } from "../../company/employees/employee-list/employees-list.component";
import { EmployeesModule } from "../../company/employees/employes.module";
import { IssueRelationsComponent } from './issue-relations/issue-relations.component';
import { IssueWorklogsComponent } from './issue-worklogs/issue-worklogs.component';
import { IssueService } from "../issue.service";

@NgModule({
    imports: [ 
        SharedModule,
        IssueDetailsRouting,
        CustomersListModule, 
        ProjectsRowsModule, 
        EmployeesModule],
    declarations: [
        IssueDetailsComponent,
        IssueHeaderComponent,
        IssueElementsComponent,
        IssueElementModalComponent,
        IssueRelationsComponent,
        IssueWorklogsComponent
    ],
    entryComponents: [ProjectRowsComponent, EmployeesListComponent],
    providers: [ IssuesRest ]
  })
  export class IssueDetailsModule { }